import {getDataset} from '../../../../../../common/shared/utils/getDataset';
import {PartialFrameElements} from '../type/PartialFrameElements.interface';
import {TextViewerCoreOption} from '../type/TextViewerCoreOption.type';
import {applyImageFeaturesInContentElement} from './applyImageFeaturesInContentElement';
import {fixImageSizesInContentElement} from './fixImageSizesInContentElement';
import {loadImagesInContentElement} from './loadImagesInContentElement';

/**
 * ContentElement 내 이미지를 고치는 함수
 *
 * 이미지에 필요한 작업을 일괄 처리합니다.
 */
export async function reviseImagesInContentElement({
  frameElements,
  option,
  onClickImage,
  showOriginalSrc = true,
  isPageTextViewer,
}: {
  frameElements: PartialFrameElements;
  option: TextViewerCoreOption;
  onClickImage?: (element: HTMLImageElement | SVGSVGElement) => void;
  showOriginalSrc?: boolean;
  isPageTextViewer: boolean;
}) {
  await loadImagesInContentElement({
    frameElements,
    useDummySrc: true,
  });
  fixImageSizesInContentElement({frameElements, option, isPageTextViewer});

  // 원본 이미지 로드는 기다릴 필요가 없습니다. 로드 후 계산 사이즈만 동일하게 맞을 수 있도록 처리합니다.
  if (showOriginalSrc) {
    loadImagesInContentElement({frameElements}).then(({loadedImgElements}) => {
      loadedImgElements.forEach(imgElement => {
        const fixedWidth = Number(getDataset(imgElement, 'fixedWidth'));
        const fixedHeight = Number(getDataset(imgElement, 'fixedHeight'));
        if (fixedWidth && fixedHeight) {
          imgElement.style.width = `${fixedWidth}px`;
          imgElement.style.height = `${fixedHeight}px`;
        } else {
          fixImageSizesInContentElement({
            frameElements,
            option,
            isPageTextViewer,
          });
        }
      });
    });
  }

  applyImageFeaturesInContentElement({frameElements, onClickImage});
}
